import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  SettlementRouter: Array<RouteRecordRaw> = [
    {
        path: '/settlement',
        name: '线下结算',
        component: Layout,
        meta: { title: '线下结算', icon: 'icon-lock', alwaysShow: true },
        children: [
            {
                path: 'one-settlement',
                name: '一单一结',
                component: () => import('@/views/settlement/OneSettlement.vue'),
                meta: { title: '一单一结' }
            },
        ]
    }
]

export default  SettlementRouter